import React, { useEffect, useState } from "react";
import { Create, SimpleForm, TextInput, required, DateInput, AutocompleteInput, RadioButtonGroupInput, useRedirect, useNotify, FileInput, FileField, SelectInput } from "react-admin";
import { getNameAndCompanyNamewithAddress, invoiceChoices } from "../common";
import { useLocation } from "react-router-dom";

const InvoiceHistoryCreate = () => {
  const [customers,setCustomers]=useState([]);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [customerId,setCustomerId]=useState(searchParams.get("customer"));
  const [contract,setContract]=useState(null);
  const [isPay,setIsPay] = useState(0);
  const redirect = useRedirect();
  const notify = useNotify();
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/all`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchUser();
  }, []);

  useEffect(()=>{
    const fetchContractInfo = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/contract/${customerId}`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setContract(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    if(customerId){
      fetchContractInfo();
    }
  },[customerId])

  return (
    <>
    {customers &&
      <Create mutationMode="pessimistic"
          mutationOptions={{ 
          onSuccess: () => {
            notify('作成が完了しました', { type: 'success' }); 
            // redirect('list', 'invoiceHistory');
            window.history.back();
          }
        }}
      >
      <SimpleForm
        onKeyDown={e => {
          if (e.key === 'Enter') {
              e.preventDefault();
          }
        }}
      >
        <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
          <AutocompleteInput
            source="customerId"
            label="顧客名"
            choices={customers.map(req => ({
              id: req.id, 
              name: `${getNameAndCompanyNamewithAddress(req)}`
            }))}
            validate={required()}
            defaultValue={customerId}
            onChange={(e) => setCustomerId(e)}
            allowEmpty
            freeSolo  
            style={{marginRight:"10px"}}
          />
          <SelectInput
            source="invoiceCategory"
            label="請求対象区分"
            choices={invoiceChoices}
            style={{marginLeft:"10px"}}
          />
        </div>
        <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
          <DateInput source="invoiceDate" label="請求日" style={{marginRight:"10px"}} inputProps={{ max: '9999-12-31' }}/>
          <TextInput source="invoiceAmount" label="請求金額(税抜き)" style={{marginLeft:"10px",marginRight:"10px"}} defaultValue={contract && contract.contractAmount && contract.contractAmount.toLocaleString()} />
          <SelectInput source="payMethod" label="支払い方法" choices={[
                { id: "持参", name: "持参" },
                { id: "振り込み", name: "振り込み" },
                { id: "集金", name: "集金" }
              ]} style={{marginLeft:"10px"}}/>
        </div>
        <DateInput source="reissueDate" label="再発行日" inputProps={{ max: '9999-12-31' }}/>
        <RadioButtonGroupInput
          source="isPay"
          label="領収"
          choices={[
            { id: 1, name: '領収済み' },
            { id: 0, name: '未領収' }
          ]}
          validate={required()}
          defaultValue={isPay}
          onChange={(e) => setIsPay(Number(e.target.value))}
        />
        <DateInput source="receiptDate" label="領収日" disabled={!isPay} inputProps={{ max: '9999-12-31' }}/>
        <FileInput source="documentURL" label="請求書" accept="application/pdf, image/*">
          <FileField source="src" title="title" />
        </FileInput>
        </SimpleForm>
      </Create>
    }
    </>
  )

};

export default InvoiceHistoryCreate;
